import {useOnMount} from 'shared/web';

interface RunOnMountProps {
  onMount: () => void;
}

/** Runs `onMount` once per mount; change its `key` to run it again. Renders nothing. */
export function RunOnMount(props: RunOnMountProps) {
  useOnMount(props.onMount);

  return null;
}
